import { Failure, Ok } from "@megaron/result";

import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const boolean: Serializer<boolean> & SerializerExtensions<boolean> = {
  serialize: (value) => {
    if (typeof value !== "boolean") throw new Error("Invalid boolean: " + value);
    return value;
  },
  deserialize: (raw) => {
    if (raw === null || raw === undefined) return Failure("InvalidBoolean");
    if (typeof raw === "string") {
      if (raw.toLowerCase() === "false") return Ok(false);
      if (raw.toLowerCase() === "true") return Ok(true);
    }
    return Ok(Boolean(raw));
  },
  ...serializerExtensions(),
};

export const booleanString: Serializer<boolean> & SerializerExtensions<boolean> = {
  serialize: (value) => value.toString(),
  deserialize: (raw) => {
    if (typeof raw !== "string") return Failure("InvalidBooleanString");
    if (raw.toLowerCase() === "false") return Ok(false);
    if (raw.toLowerCase() === "true") return Ok(true);
    else return Failure("InvalidBooleanString");
  },
  ...serializerExtensions(),
};
